<template>
    <div class="page-container onboarding-container" :class="childClass">
        <transition name="fade">
            <div v-show="dataSaving || isLoading" class="loading-overlay" style="transition-delay: 0.3s">
                <loader></loader>
            </div>
        </transition>
        <div class="wtw-container full center allow-scrolling" :class="childClass">
            <div class="step-title-container" v-if="currentStep.title">
                <div class="step-title">
                    {{ currentStep.title }}
                    <div class="step-subtitle" v-if="currentStep.subTitle">
                        {{ currentStep.subTitle }}
                    </div>
                </div>
            </div>
            <component v-if="currentStep.type" :is="'step-' + currentStep.type"
                       :options="currentStep.options.product_option_values"
                       :sendOptions="sendOptions"
                       :key="currentStep.token"
                       :optionsAll="currentStep.options"
                       :errorMessage="errorMessage"
                       :optionsSelected="userOptionValues"
                       :riskValueSelected="userRiskValue"
                       :extraData="currentStep.extraData"
                       :class="{'no-skip-message-padding': noSkipMessage, 'is-loading': isLoading}"
            ></component>
        </div>
        <div class="bottom-nav">
            <div class="next-button full" :class="{'no-skip-message': noSkipMessage}">
                <div class="wtw-container">

                    <span v-show="noSkipMessage" class="error-message">{{ noSkipMessage }}</span>
                    <div @click.stop="nextStepWithSave"
                        class="button pink full-width small-font">
                        {{currentStep.nextBtnTitle || 'Next'}}
                    </div>
                </div>
            </div>
            <div v-if="currentStep.noSkip" class="back-button">
                <div @click.stop="prevStep"
                    class="button column small-font">
                    <img :src="imageUrl('back.svg')"/> Back
                </div>
            </div>
            <div v-else-if="!currentStep.isForm && !currentStep.noSkip"
                class="skip-back-buttons">
                <div @click.stop="prevStep"
                    class="button column small-font">
                    <img :src="imageUrl('back.svg')"/> Back
                </div>
                <div @click.stop="nextStep"
                    class="button column small-font">
                    Skip <img :src="imageUrl('forward.svg')"/>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import {mapGetters} from "vuex";
    import FullList from "./steps/full-list.vue";
    import ColumnList from "./steps/column-list.vue";
    import OutfitType from "./steps/outfit-type.vue";
    import Birth from "./steps/birth.vue";
    import Color from "./steps/color.vue";
    import Size from "./steps/size.vue";
    import Store from "./steps/store.vue";
    import Risk from "./steps/risk.vue";
    import Account from "./steps/account.vue";
    import Billing from "./steps/billing.vue";
    import Agreements from "./steps/agreements.vue";
    import Mixins from "../../mixins/mixins";

    import Loader from "../common/loader.vue";

    import $ from "webpack-zepto";

    export default {
        mixins: [Mixins],
        components: {
            "step-full-list": FullList,
            "step-column-list": ColumnList,
            "step-outfit-type": OutfitType,
            "step-color": Color,
            "step-size": Size,
            "step-store": Store,
            "step-risk": Risk,
            "step-account": Account,
            "step-billing": Billing,
            "step-birth": Birth,
            "step-agreements": Agreements,
            Loader
        },
        data() {
            return {
                sendOptions: false,
                errorMessage: null,
                noSkipMessage: null,
                dataSaving: false,
                childClass: '',
                isLoading: false,
            };
        },
        computed: {
            currentProgress() {
                return (this.stepNumber + 1) / this.numberOfSteps * 100;
            },
            stepNumber() {
                return parseInt(this.$route.params.id) - 1;
            },
            ...mapGetters({
                step: "onboarding/step",
                numberOfSteps: "onboarding/numberOfSteps",
                userOptionValues: "onboarding/userOptionValues",
                userRiskValue: "onboarding/userRiskValue"
            }),
            currentStep() {
                return this.step(this.stepNumber);
            },
            getNoSkip () {
                return this.currentStep.noSkip;
            }
        },
        created() {
            $(window).scrollTop(0);

            this.$on("removeOptions", optionValues => {
                this.$store.commit("onboarding/removeUserOptionValues", optionValues);
            });

            this.$on("optionsSending", function(optionValues, canGoToNextStep, extraData) {
                this.sendOptions = false;
                if(canGoToNextStep) {
                    this.noSkipMessage = null;
                    this.$store.commit("onboarding/addUserOptionValues", optionValues);
                    this.$store.commit("onboarding/setExtraData", { stepNumber: this.stepNumber, extraData });
                    this.nextStep();
                } else if(!this.currentStep.noSkipMessage) {
                    this.noSkipMessage = 'Please select on option to continue.'
                }

            });

            this.$on("riskValueSending", function(value, canGoToNextStep) {
                this.sendOptions = false;
                if(canGoToNextStep) {
                    this.noSkipMessage = null;
                    this.$store.commit("onboarding/setUserRiskValue", value);
                    this.nextStep();
                } else {
                    this.noSkipMessage = 'Please select on option to continue.'
                }
            });

            this.$on("acceptingAgreements", function(value, canGoToNextStep) {
                this.sendOptions = false;
                if(canGoToNextStep) {
                    this.noSkipMessage = null;
                    this.nextStep();
                } else {
                    this.noSkipMessage = 'Please accept all the agreements above.'
                }
            });

            this.$on("registerUser", user => {
                this.sendOptions = false;
                user.profile_risk = this.userRiskValue;
                this.dataSaving = true;
                this.$store
                        .dispatch("auth/registerUser", {
                            user,
                            userOptionValues: this.userOptionValues
                        })
                        .then(() => {
                            this.$store.dispatch({
                                type: "config/fetchCredentials",
                            }).then(() => {
                                this.$store.commit("onboarding/resetUserOptionValues");
                                this.$router.push({path: '/training/1' });
                                this.dataSaving = false;
                            });
                        })
                        .catch((response) => {
                            this.sendOptions = false;
                            this.dataSaving = false;
                            this.errorMessage = response;
                        });
            });

            this.$on("changeChildClass", _class => this.childClass = _class);
            
            this.$store.commit('menu/setTotalProgressSteps', this.numberOfSteps + 3);
        },
        methods: {
            fetchStepData() {
                this.isLoading = true;
                this.$store.commit('menu/setCurrentProgressStep', this.stepNumber + 1);
                this.$store.dispatch("onboarding/loadStep", this.stepNumber)
                    .finally(() => {
                        this.isLoading = false;
                    });
            },
            nextStepWithSave() {
                this.sendOptions = true;
            },
            nextStep() {
                let nextStep = this.stepNumber + 2;
                if (nextStep <= this.numberOfSteps) {
                    this.visitStepNumber(nextStep);
                }
            },
           prevStep() {
                if(this.stepNumber) {
                   this.visitStepNumber(this.stepNumber); 
                } else {
                    this.$router.push({ path: '/intro' }) 
                }
            },
            visitStepNumber(stepNumber) {
                this.$router.push({path: "/signup/" + stepNumber});
            },
        },
        watch: {
            "$route.params.id": {
                handler: "fetchStepData",
                immediate: true
            },
        },
    };
</script>
